/* eslint-disable no-alert */
import React, { useState } from 'react';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';

export const RadioGroupQtn = (props) => {
  const updatedRadio = (e) => {
    // updateAnswers([e.target.value]);
  };
  const [question] = useState(props);
  question?.qstn?.options.sort((a, b) => {
    return parseInt(a.order, 10) - parseInt(b.order, 10);
  });

  return (
    <RadioGroup
      label={<strong>{`${question.serial}. ${question.qstn?.questionText}`}</strong>}
      model={`qstn-${question?.qstn?.questionId}`}
      key={`radio-${question?.qstn?.questionId}`}
      validators={{ required: 'Please select an option' }}
      onChange={updatedRadio}
    >
      <RadioGroup.Column>
        {question.qstn?.options.map((option, idx) => {
          return (
            <RadioGroup.Radio
              label={option.values[0].value}
              value={option.values[0].id}
              key={option.id}
            />
          );
        })}
      </RadioGroup.Column>
    </RadioGroup>
  );
};
